'use client';

import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/common/Header';
import FooterWrapper from '@/components/common/FooterWrapper';


const DeliveryAndPaymentTermsInteractive = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-primary-dark to-primary flex flex-col">
      <Header />
      
      <main className="flex-1 py-16 lg:py-24">
        <div className="mx-auto max-w-content px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6">
              {t('deliveryAndPayment.title')}
            </h1>
            <div className="w-24 h-1 bg-accent mx-auto"></div>
          </div>

          {/* Content */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-luxury p-8 lg:p-12 space-y-12">
            {/* Section 1 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section1.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('deliveryAndPayment.section1.content')}
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section2.title')}
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  {t('deliveryAndPayment.section2.content1')}
                </p>
                <p>
                  {t('deliveryAndPayment.section2.content2')}
                </p>
                <p>
                  {t('deliveryAndPayment.section2.content3')}
                </p>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section3.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('deliveryAndPayment.section3.content')}
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section4.title')}
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>{t('deliveryAndPayment.section4.content1')}</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>{t('deliveryAndPayment.section4.item1')}</li>
                  <li>{t('deliveryAndPayment.section4.item2')}</li>
                </ul>
                <p>{t('deliveryAndPayment.section4.content2')}</p>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section5.title')}
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  {t('deliveryAndPayment.section5.content1')}
                </p>
                <p>
                  {t('deliveryAndPayment.section5.content2')}
                </p>
              </div>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section6.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('deliveryAndPayment.section6.content1')}
              </p>
              <p className="text-gray-700 leading-relaxed font-semibold mt-2">
                {t('deliveryAndPayment.section6.content2')}
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="font-heading text-2xl font-bold text-primary mb-4">
                {t('deliveryAndPayment.section7.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('deliveryAndPayment.section7.content')}
              </p>
            </section>
          </div>
        </div>
      </main>

      <FooterWrapper />
    </div>
  );
};

export default DeliveryAndPaymentTermsInteractive;